import { render, staticRenderFns } from "./ResearchCard.vue?vue&type=template&id=4b5137ec&"
import script from "./ResearchCard.vue?vue&type=script&lang=js&"
export * from "./ResearchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports